module.exports = __webpack_public_path__ + "img/xin-gigwi.f44f6d80.png";